import { render, staticRenderFns } from "./DetailsMain.vue?vue&type=template&id=6c20e1ba&scoped=true&"
import script from "./DetailsMain.vue?vue&type=script&lang=js&"
export * from "./DetailsMain.vue?vue&type=script&lang=js&"
import style0 from "./DetailsMain.vue?vue&type=style&index=0&id=6c20e1ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c20e1ba",
  null
  
)

/* custom blocks */
import block0 from "./DetailsMain.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports